import { useDispatch, useSelector } from 'react-redux';
import { selectWorkplaceViolenceCoverageLimit } from '../../../../selectors/application';
import { setWorkplaceViolenceCoverage, setCheckedEndorsement } from '../../../../actions/application';
import { EndorsementKey } from '../../types';
import EndorsementSummaryCardLayout from '../../../Summary/Endorsements/EndorsementSummaryCardLayout';

const WorkplaceViolenceSummaryCard = ({ value }: { value: any }) => {
  const dispatch = useDispatch();
  const workplaceViolenceCoverageLimit = useSelector(selectWorkplaceViolenceCoverageLimit);
  const is50_50 = workplaceViolenceCoverageLimit === '50000/50000';

  const coverageInfo = [
    { coverage: 'Per Event', limit: is50_50 ? '$50,000' : '$100,000' },
    { coverage: 'Aggregate', limit: is50_50 ? '$50,000' : '$100,000' },
  ];

  const handleRemove = () => {
    dispatch(setCheckedEndorsement(EndorsementKey.WorkplaceViolenceCoverage, false));
    dispatch(setWorkplaceViolenceCoverage(null));
  };

  const handleRestore = () => {
    dispatch(setCheckedEndorsement(EndorsementKey.WorkplaceViolenceCoverage, true));
    dispatch(setWorkplaceViolenceCoverage(value));
  };

  return (
    <EndorsementSummaryCardLayout
      label="Workplace Violence Coverage"
      coverageInfo={coverageInfo}
      onRemove={handleRemove}
      onRestore={handleRestore}
    />
  );
};

export default WorkplaceViolenceSummaryCard;
